<button (click)="dismiss()" type="button" class="mui-modal__close" aria-label="Close">
  <i mui-icon font="fa" name="times"></i>
</button>
<div class="mui-modal__header">
  <h3 class="mui-modal__title">
    {{ 'global.fullAppTitle' | translate }}
  </h3>
  <p class="subtitle">{{ 'planPermission.modal.subtitle' | translate }}</p>

  <div class="rocket-circle">
    <svg width="40" height="40" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.375 40.001c.243 0 .618-.088.836-.196l7.71-3.86c1.144-.57 2.071-2.07 2.071-3.348v-7.932C35.672 21.01 40 16.113 40 8.047c.006-1.995.006-3.984-.54-6.536-.094-.438-.527-.87-.966-.964C35.947 0 33.953 0 31.966 0c-8.104 0-12.982 4.305-16.632 10H7.412c-1.277.001-2.777.928-3.35 2.07l-3.86 7.718a2.225 2.225 0 00-.197.837c0 1.035.84 1.875 1.874 1.875h7.236l-.828 1.673a2.945 2.945 0 00-.256 1.098c0 .572.33 1.362.737 1.764l4.2 4.197c1.216 1.214 2.643.588 2.863.48l1.669-.827v7.241c0 1.035.84 1.875 1.875 1.875zm-4.392-12.053l-2.93-2.93c1.765-3.569 5.02-10.155 6.461-13.038 3.703-5.767 7.736-8.23 13.452-8.23 1.407 0 2.678 0 4.107.183.186 1.463.18 2.757.175 4.113.002 5.686-2.465 9.713-8.235 13.438a4581.263 4581.263 0 01-13.03 6.464zM28.75 14.375a3.126 3.126 0 000-6.25 3.126 3.126 0 000 6.25z"
        fill="#000"
        fill-rule="nonzero"
        fill-opacity=".6" />
    </svg>
  </div>

  <p *mmuUserRole="[roles.BASIC]" class="infotext">{{ 'planPermission.modal.basicInfoText' | translate }}</p>
  <p *mmuUserRole="[roles.ADMIN, roles.ENGINEER]" class="infotext">{{ 'planPermission.modal.adminInfoText' | translate }}</p>
  <button *mmuUserRole="[roles.BASIC]" mui-btn appearance="secondary" class="mui-modal__button" (click)="dismiss()">
    {{ 'planPermission.modal.basicButton' | translate }}
  </button>
  <a *mmuUserRole="[roles.ADMIN, roles.ENGINEER]" mui-btn appearance="primary" class="mui-modal__button" href="/pages/subscription/">
    {{ 'planPermission.modal.adminButton' | translate }}
  </a>
</div>
